import { render, staticRenderFns } from "./AtomSelectYear.vue?vue&type=template&id=2b650444&scoped=true"
import script from "./AtomSelectYear.vue?vue&type=script&lang=ts"
export * from "./AtomSelectYear.vue?vue&type=script&lang=ts"
import style0 from "./AtomSelectYear.vue?vue&type=style&index=0&id=2b650444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b650444",
  null
  
)

export default component.exports